document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-team-button').forEach((button) => {

    const component = button.closest('.b-team');
    const itemsElement = component.querySelector('.js-team-items');
    const showButton = component.querySelector('.js-team-button-show');
    const hideButton = component.querySelector('.js-team-button-hide');

    const TRANSITION_DURATION = 500; // doit correspondre à $transition-duration dans le SCSS

    button.addEventListener('click', (event) => {
      event.preventDefault();

      const isVisible = itemsElement.getAttribute('aria-hidden') === 'false';

      if (isVisible) {
        // Fixer la hauteur actuelle avant d'animer vers 0
        itemsElement.style.maxHeight = itemsElement.scrollHeight + 'px';
        // Forcer un reflow pour que la valeur soit prise en compte
        itemsElement.getBoundingClientRect();
        itemsElement.style.maxHeight = '0px';
        itemsElement.setAttribute('aria-hidden', 'true');
        showButton.setAttribute('aria-hidden', 'false');
        hideButton.setAttribute('aria-hidden', 'true');
        showButton.focus();
      }
      else {
        itemsElement.style.maxHeight = itemsElement.scrollHeight + 'px';
        itemsElement.setAttribute('aria-hidden', 'false');
        showButton.setAttribute('aria-hidden', 'true');
        hideButton.setAttribute('aria-hidden', 'false');
        hideButton.focus();
        // Après la transition, libérer la contrainte de hauteur
        setTimeout(() => {
          if (itemsElement.getAttribute('aria-hidden') === 'false') {
            itemsElement.style.maxHeight = 'none';
          }
        }, TRANSITION_DURATION);
      }
    });

  });
});
